import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';

import { convertDate, getCostSymbol, returnComma } from '../../common/Utils';
import _Fetch from '../../common/Fetches';
import { getItem } from '../../common/StorageUtils';

import DivButton from '../../components/button/DivButton';
import CartItem from '../../components/item/OrderDetailItem';
import ConfirmCartModal from '../../components/modal/ConfirmCartModalAnoter';

class OrderHistoryDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isViewDetailModal: false,
      paymentData: null,
    };

    this.viewDetailData = null;
  }

  componentDidMount() {
    // document.body.style.overflow = 'auto';
    this.initialize();
    // this.testInitDataFectch();
  }

  async initialize() {
    try {
      const api = getItem('restAPI').model_desc.od_get_detail;
      const payApi = getItem('restAPI').model_desc.payment_get_detail;
      // console.log(this.props.data.pid_od);
      const res = await _Fetch(api, `?pid=${this.props.data.pid_od}`, []);
      const paymentRes = await _Fetch(
        payApi,
        `?pid=${this.props.data.pid_payment}`,
        [],
      );
      console.log('paymetn', paymentRes);
      // od_cust 자료가 안담겨서 리턴 될때도 있다 나중에 문제 야기시 대표님께 문의
      console.log('od', res);

      this.setState({ data: res, paymentData: paymentRes.payment });
    } catch (e) {
      console.log(e);
    }
  }

  renderModal() {
    if (this.viewDetailData) {
      return (
        <ConfirmCartModal
          data={this.viewDetailData}
          isModal={this.state.isViewDetailModal}
          onClose={() => {
            this.viewDetailData = null;
            // document.body.style.overflow = 'auto';
            this.setState({ isViewDetailModal: false });
          }}
        />
      );
    }
    return null;
  }

  render() {
    const { data, onBack } = this.props;
    const { paymentData } = this.state;

    // console.log(data);
    if (!this.state.data || !paymentData) return null;

    // 서버 get_detail은 자식이 0건이면 배열이 아니라 {code:'data/no_data'} 객체를 반환.
    // 그대로 .map/.reduce 하면 렌더가 크래시(하얀 화면)되므로 배열로 정규화.
    // 유효 주문은 이미 배열이라 동작 동일.
    const odPd = Array.isArray(this.state.data.od_pd) ? this.state.data.od_pd : [];
    const odCustList = Array.isArray(this.state.data.od_cust) ? this.state.data.od_cust : [];

    const processSubtotal = () => {
      let sum = 0;
      odPd.map(item => (sum += (item.cost - item.dis_value) * item.quantity));
      return sum;
    };
    const processDiscount = () => {
      let sum = 0;
      odPd.map(item => (sum += (item.dis_value) * item.quantity));
      return sum;
    };
    const discount = processDiscount();
    const subtotal = processSubtotal();
    const allCost = subtotal + data.cost_deli + data.tax;
    console.log(data);
    console.log('const pd', data.cost_pd, 'allCost', allCost);

    // 택배비 할인을 어떻게 적용 할건인지 데이터가 필요함
    // const discount = allCost > data.cost_pd ? allCost - data.cost_pd : 0;
    console.log(discount);
    const payMethode = (type) => {
      switch (type) {
        case  10 : return 'Paypal'
        case  11 : return 'Payment Wall'
        case  20 : return 'Paypal'
        case  21 : return 'Bank Transfer'
        case  22 : return 'Payment Wall'
        case  30 : return 'Paypal'
        case  31 : return 'Bank Transfer'
        default : return 'Inicis'
      }
    }

    return (
      <div style={styles.container}>
        {this.renderModal()}
        <DivButton style={styles.button} onClick={() => onBack()}>
          VIEW ORDER LIST
        </DivButton>

        <div style={styles.productInfoBox}>
          <div style={styles.itemBoxHeader}>
            <p style={styles.orderRevieText}>ORDER REVIEW</p>
            <p style={styles.orderNumberText}>{data.pid_od}</p>
          </div>
          <p style={styles.productTitle(16)}>
            {convertDate(data.date_creation)}
          </p>
          <p style={{ ...styles.productTitle(29), fontWeight: '600' }}>
            PRODUCT
          </p>
          <div style={styles.odrderItemBox}>
            {odPd.map((item, i) => {
              console.log('item', item);
              // 매칭되는 od_cust(디자인 데이터)가 없으면 해당 아이템 렌더 스킵(크래시 방지).
              // 유효 커스텀 주문은 항상 매칭되어 영향 없음.
              const custMatch = odCustList.filter(result => result.pid_od_pd === item.pid_od_pd)[0];
              if (!custMatch) return null;
              const obj = {
                ...item,
                body: custMatch.body,
              };
              return (
                <CartItem
                  onViewDtail={(glove) => {
                    setTimeout(() => window.scrollTo(0, 0), 1);
                    this.viewDetailData = glove;
                    this.setState({ isViewDetailModal: true });
                    // document.body.style.overflow = 'hidden';
                  }}
                  data={obj}
                  key={shortid.generate()}
                  marginBottom={i === data.length - 1 ? 17 : 20}
                />
              );
            })}
          </div>

          {discount > 0 && (
            <div style={styles.couponBox(8)}>
              <p style={styles.cartSubTotalTtitle}>Discount</p>
              <p style={{ ...styles.cartSubTotalCost, color: '#d0021b' }}>
                -{getCostSymbol(this.state.data.od.typ_cost)}
                {this.state.data.od.typ_cost === 1
                  ? returnComma(discount.toFixed(2))
                  : returnComma(discount)}
              </p>
            </div>
          )}

          <div style={styles.couponBox(10)}>
            <p style={styles.cartSubTotalTtitle}>Subtotal</p>
            <p style={styles.cartSubTotalCost}>
              {getCostSymbol(this.state.data.od.typ_cost)}
              {this.state.data.od.typ_cost === 1
                ? returnComma(subtotal.toFixed(2))
                : returnComma(subtotal)}
            </p>
          </div>

          {(() => {
            // 서버는 애드온 0건 시 배열이 아닌 {code:'data/no_data'} 객체 반환.
            // `|| []`는 truthy 객체를 못 걸러 .reduce에서 크래시 -> Array.isArray로 정규화.
            const addonList = Array.isArray(this.state.data.od_addon) ? this.state.data.od_addon : [];
            const addonCost = addonList.reduce((s, a) => s + Number(a.addon_cost || 0), 0);
            // 무료 옵션만 선택한 주문도 섹션 표시. 금액 기준으로 숨기면 무료 옵션이 누락됨
            if (addonList.length === 0) return null;
            const typCost = this.state.data.od.typ_cost;
            // 옵션명은 주문 시점 스냅샷(addon_items.title). 구 데이터는 마스터 fallback
            const names = [];
            addonList.forEach((a) => {
              if (Array.isArray(a.addon_items) && a.addon_items.length > 0) {
                a.addon_items.forEach((it) => { if (it.title) names.push(it.title); });
                return;
              }
              (a.addon_products || []).forEach((ap) => {
                const nm = typCost === 2 ? (ap.title_jp || ap.title_eng || ap.title)
                  : typCost === 3 ? (ap.title || ap.title_eng)
                  : (ap.title_eng || ap.title);
                if (nm) names.push(nm);
              });
            });
            return (
              <div style={styles.addonSummaryBox}>
                <div style={styles.addonSummaryLabel}>
                  <p style={styles.addonSummaryTitle}>Add-on Options</p>
                  {names.length > 0 && (
                    <div style={styles.addonNames}>
                      {names.map((name, index) => (
                        <span key={`${name}-${index}`} style={styles.addonName}>{name}</span>
                      ))}
                    </div>
                  )}
                </div>
                <p style={styles.cartSubTotalCost}>
                  {getCostSymbol(typCost)}
                  {typCost === 1 ? returnComma(addonCost.toFixed(2)) : returnComma(addonCost)}
                </p>
              </div>
            );
          })()}

          <div style={styles.couponBox(8)}>
            <p style={styles.cartSubTotalTtitle}>Shipping</p>
            <p style={styles.cartSubTotalCost}>
              {getCostSymbol(this.state.data.od.typ_cost)}
              {this.state.data.od.typ_cost === 1
                ? returnComma(data.cost_deli.toFixed(2))
                : returnComma(data.cost_deli)}
            </p>
          </div>

          {this.state.data.od.typ_cost === 2 && (
            <div style={styles.couponBox(8)}>
              <p style={styles.cartSubTotalTtitle}>Tax</p>
              <p style={styles.cartSubTotalCost}>
                {getCostSymbol(this.state.data.od.typ_cost)}
                {this.state.data.od.typ_cost === 1
                  ? returnComma(data.tax.toFixed(2))
                  : returnComma(data.tax)}
              </p>
            </div>
          )}

          <div style={styles.cartUnderline} />

          <div style={styles.totalBox}>
            <p style={styles.totalText}>Total</p>
            <p style={styles.totalCost}>
              {getCostSymbol(this.state.data.od.typ_cost)}
              {this.state.data.od.typ_cost === 1
                ? returnComma((parseFloat(data.cost_pd) + parseFloat(data.cost_deli)).toFixed(2))
                : returnComma(parseFloat(data.cost_pd) + parseFloat(data.cost_deli))}
            </p>
          </div>
        </div>

        <div style={styles.productInfoBox}>
          <p style={styles.orderInfoTitle}>ORDER INFORMATION</p>

          <div style={styles.paymentBox}>
            <p style={styles.addrTitle}>Shippiing Address</p>
            <p style={styles.addrText}>
              {this.state.data.od_addr[0].addr_etc === 'none' || !this.state.data.od_addr[0].addr_etc
                ? null
                : `${this.state.data.od_addr[0].addr_etc}, `}
              {`${this.state.data.od_addr[0].addr}, ${
                this.state.data.od_addr[0].city
              }, ${this.state.data.od_addr[0].state}, ${
                this.state.data.od_addr[0].country
              }`}
              <br />
              Zip : {this.state.data.od_addr[0].zipcode}
              <br />
            </p>
          </div>

          <div style={styles.paymentBox}>
            <p style={styles.addrTitle}>Payment Method</p>
            <p style={styles.addrText}>
              {
                payMethode(paymentData.typ_pay )
              }
            </p>
          </div>
        </div>
      </div>
    );
  }
}

OrderHistoryDetail.propTypes = {
  data: PropTypes.object,
  onBack: PropTypes.func,
};

OrderHistoryDetail.defaultProps = {
  data: null,
  onBack: () => {},
};

const styles = {
  container: {
    width: 718,
    marginLeft: 45,
  },
  odrderItemBox: {
    width: 624,
    margin: 'auto',
    marginTop: 24,
  },
  cartSubTotalTtitle: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    letterSpacing: 0.9,
    color: '#251f1b',
    width: 280,
    textAlign: 'left',
  },
  orderInfoTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    lineHeight: 1.39,
    letterSpacing: 1,
    color: '#251f1b',
    marginTop: 24,
    marginLeft: 30,
  },
  button: {
    width: 240,
    height: 40,
    backgroundColor: '#000',
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
    letterSpacing: 0.2,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
  },
  productInfoBox: {
    width: 740,
    border: 'solid 1px rgba(21, 41, 53, 0.1)',
    marginTop: 24,
    backgroundColor: '#fff',
  },
  itemBoxHeader: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 58,
    marginTop: 30,
  },
  orderRevieText: {
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: 1.39,
    letterSpacing: 1,
    color: '#251f1b',
  },
  orderNumberText: {
    marginLeft: 31,
    fontSize: 18,
    lineHeight: 1.39,
    color: '#251f1b',
  },
  productTitle: marginTop => ({
    color: '#251f1b',
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    lineHeight: 1.56,
    letterSpacing: 0.9,
    marginTop,
    marginLeft: 58,
  }),
  cartUnderline: {
    width: 624,
    height: 2,
    backgroundColor: 'rgba(21, 41, 53, 0.1)',
    margin: 'auto',
    marginTop: 30,
  },
  couponBox: marginTop => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop,
    marginRight: 58,
    minHeight: 24,
    alignItems: 'center',
  }),
  addonSummaryBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    marginTop: 12,
    marginRight: 58,
  },
  addonSummaryLabel: {
    width: 280,
  },
  addonSummaryTitle: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    letterSpacing: 0.9,
    lineHeight: 1.5,
    color: '#251f1b',
  },
  addonNames: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    marginTop: 4,
  },
  addonName: {
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    letterSpacing: 0.4,
    lineHeight: 1.45,
    color: 'rgba(37, 31, 27, 0.68)',
  },
  totalBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 28,
    marginRight: 58,
    justifyContent: 'flex-end',
    marginBottom: 28,
  },
  totalText: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    color: '#251f1b',
    lineHeight: 1.38,
    letterSpacing: 0.9,
    fontWeight: '600',
    width: 280,
  },
  totalCost: {
    fontFamily: 'Roboto Condensed',
    fontSize: 24,
    textAlign: 'right',
    color: '#251f1b',
    lineHeight: 1.25,
    letterSpacing: 1.5,
    fontWeight: '600',
    width: 150,
  },
  cartSubTotalCost: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    letterSpacing: 0.9,
    color: '#251f1b',
    width: 150,
    textAlign: 'right',
  },
  paymentBox: {
    marginTop: 16,
    marginLeft: 30,
    marginBottom: 24,
  },
  addrTitle: {
    fontSize: 18,
    fontWeight: '600',
    lineHeight: 1.39,
    letterSpacing: 1,
    color: '#251f1b',
  },
  addrText: {
    marginTop: 8,
    fontSize: 16,
    color: '#251f1b',
  },
};

export default OrderHistoryDetail;
